import React from 'react';

interface AgalliaoLogoProps {
  className?: string;
  strokeWidth?: number;
  color?: string;
}

const AgalliaoLogo: React.FC<AgalliaoLogoProps> = ({ 
  className = "w-10 h-10", 
}) => {
  return (
    <img 
      src="/agalliao.png" 
      alt="Agalliao Corporation" 
      className={`${className} object-contain`} 
      referrerPolicy="no-referrer"
    />
  );
};

export default AgalliaoLogo;
